import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// @ts-ignore

/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
var defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */

export var MegaMenuItemFragmentFragmentDoc = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment MegaMenuItemFragment on MegaMenuItem {\n  id\n  slug\n  url\n  name\n}\n    "])));
export var FooterDataDocument = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    query FooterData {\n  footer {\n    navigationLinkColumns {\n      columnTitle\n      links {\n        text\n        url\n        openInNewWindow\n        isBrightEdgeAutoPilotEnabled\n      }\n    }\n    appDownloadLinks {\n      name\n      url\n    }\n    copyright\n  }\n}\n    "])));
/**
 * __useFooterDataQuery__
 *
 * To run a query within a React component, call `useFooterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useFooterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFooterDataQuery({
 *   variables: {
 *   },
 * });
 */

export function useFooterDataQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(FooterDataDocument, options);
}
export function useFooterDataLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(FooterDataDocument, options);
}
export function useFooterDataSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(FooterDataDocument, options);
}
export var HeaderConfigurationDocument = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    query HeaderConfiguration($domain: String!, $showAdultShopMenu: Boolean!, $isTacticalCategoryExperiment: Boolean) {\n  cmsConfiguration {\n    header(input: {domain: $domain}) {\n      meta {\n        salesChannel {\n          code\n        }\n      }\n      topHeader {\n        leftSection {\n          name\n          url\n          icon\n          iconSize\n        }\n        rightSection {\n          name\n          url\n          icon\n          iconSize\n        }\n      }\n      primaryHeader {\n        logo {\n          imageSrc\n          alt\n          url\n          enabled\n          condensedImageSrc\n        }\n        searchBar {\n          enabled\n        }\n        club {\n          enabled\n          clubCatchTileEnabled\n        }\n        clubFlybuys {\n          enabled\n        }\n        cart {\n          enabled\n        }\n        flybuys {\n          enabled\n        }\n        wishlist {\n          enabled\n        }\n        myAccount {\n          enabled\n          showFlybuysLink\n        }\n      }\n      headerTheme\n      megaMenu(\n        input: {showAdultShopMenu: $showAdultShopMenu, isTacticalCategoryExperiment: $isTacticalCategoryExperiment}\n      ) {\n        navData {\n          shops {\n            id\n            slug\n            name\n            url\n            pinToTop\n            shopNavigationGroups {\n              id\n              slug\n              name\n              url\n              shopNavigationItems {\n                id\n                slug\n                name\n                url\n              }\n            }\n            topBrands {\n              id\n              slug\n              name\n              url\n            }\n          }\n          items {\n            ...MegaMenuItemFragment\n            topBrands {\n              id\n              name\n              slug\n              url\n            }\n            children {\n              ...MegaMenuItemFragment\n              children {\n                ...MegaMenuItemFragment\n              }\n            }\n          }\n          pinToTopItems {\n            ...MegaMenuItemFragment\n          }\n          catchEssentialsMenu {\n            giftCards\n            catchMobile\n          }\n          accountMenu {\n            loggedInMenu {\n              name\n              url\n            }\n            loggedOutMenu {\n              name\n              url\n            }\n          }\n        }\n      }\n    }\n  }\n}\n    ", ""])), MegaMenuItemFragmentFragmentDoc);
/**
 * __useHeaderConfigurationQuery__
 *
 * To run a query within a React component, call `useHeaderConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHeaderConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHeaderConfigurationQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *      showAdultShopMenu: // value for 'showAdultShopMenu'
 *      isTacticalCategoryExperiment: // value for 'isTacticalCategoryExperiment'
 *   },
 * });
 */

export function useHeaderConfigurationQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(HeaderConfigurationDocument, options);
}
export function useHeaderConfigurationLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(HeaderConfigurationDocument, options);
}
export function useHeaderConfigurationSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(HeaderConfigurationDocument, options);
}
export var GetSnowplowConfigurationDocument = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    query GetSnowplowConfiguration($domain: String) {\n  cmsConfiguration {\n    analytics {\n      snowplow(input: {domain: $domain}) {\n        appId\n        eventMethod\n        platform\n        contexts {\n          webPage\n        }\n        collectorUrl\n        scriptSrc\n        cookieDomain\n        pageUnloadTimer\n      }\n    }\n  }\n}\n    "])));
/**
 * __useGetSnowplowConfigurationQuery__
 *
 * To run a query within a React component, call `useGetSnowplowConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSnowplowConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSnowplowConfigurationQuery({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */

export function useGetSnowplowConfigurationQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(GetSnowplowConfigurationDocument, options);
}
export function useGetSnowplowConfigurationLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(GetSnowplowConfigurationDocument, options);
}
export function useGetSnowplowConfigurationSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(GetSnowplowConfigurationDocument, options);
}
export var TrendingProductsDocument = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    query TrendingProducts($includeAdultCategory: Boolean!, $inStock: Boolean!, $limit: Int!) {\n  trendingProducts(\n    input: {includeAdultCategory: $includeAdultCategory, inStock: $inStock, limit: $limit}\n  ) {\n    products {\n      id\n      title\n      ratingsSummary {\n        numberOfRatings\n        averageRating\n      }\n      assets {\n        hero {\n          url\n          altText\n        }\n      }\n      brand {\n        name\n        slug\n      }\n      priceTag {\n        priceDiscount {\n          label\n          percentageLabel\n          endDate\n        }\n        topLabel\n        priceLabel {\n          wasPrice {\n            amount\n          }\n          price {\n            amount\n          }\n          saving {\n            label\n            savingAmount {\n              amount\n            }\n          }\n        }\n        clubSellPrice {\n          amount\n        }\n        clubExclusive\n        enabled\n        retailPriceDisclaimer {\n          description\n        }\n      }\n      bestOffer {\n        id\n        clubExclusive\n        clubFreeShipping\n        freeShipping\n        seller {\n          id\n          name\n        }\n      }\n      options {\n        name\n      }\n      sellable\n      slug\n      adult\n    }\n    metaData {\n      preHydrationCount\n      postHydrationCount\n      hydrationErrorCount\n    }\n  }\n}\n    "])));
/**
 * __useTrendingProductsQuery__
 *
 * To run a query within a React component, call `useTrendingProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingProductsQuery({
 *   variables: {
 *      includeAdultCategory: // value for 'includeAdultCategory'
 *      inStock: // value for 'inStock'
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useTrendingProductsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(TrendingProductsDocument, options);
}
export function useTrendingProductsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(TrendingProductsDocument, options);
}
export function useTrendingProductsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(TrendingProductsDocument, options);
}
export var TrendingSearchTermsDocument = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    query TrendingSearchTerms($limit: Int!) {\n  trendingSearchTerms(input: {limit: $limit}) {\n    terms\n  }\n}\n    "])));
/**
 * __useTrendingSearchTermsQuery__
 *
 * To run a query within a React component, call `useTrendingSearchTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingSearchTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingSearchTermsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */

export function useTrendingSearchTermsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(TrendingSearchTermsDocument, options);
}
export function useTrendingSearchTermsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(TrendingSearchTermsDocument, options);
}
export function useTrendingSearchTermsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(TrendingSearchTermsDocument, options);
}
export var SearchRedirectsDocument = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    query SearchRedirects {\n  searchRedirects {\n    redirects {\n      searchTerm\n      targetPath\n    }\n  }\n}\n    "])));
/**
 * __useSearchRedirectsQuery__
 *
 * To run a query within a React component, call `useSearchRedirectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRedirectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRedirectsQuery({
 *   variables: {
 *   },
 * });
 */

export function useSearchRedirectsQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useQuery(SearchRedirectsDocument, options);
}
export function useSearchRedirectsLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useLazyQuery(SearchRedirectsDocument, options);
}
export function useSearchRedirectsSuspenseQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);

  return Apollo.useSuspenseQuery(SearchRedirectsDocument, options);
}